<div class="pet-card-shell" id="mascota{{mascota.ma_id}}"
     [class.blur-strong]="app.misdatos.rol == 'no_publico' && app.misdatos.ID != app.perfil.ID">
  <article class="pet-card" [attr.data-type]="mascota.ma_tipo">
    <div class="pet-card-main">
    <div class="pet-card-media position-relative">
      <img
        [src]="fotoSeleccionada || mascota.foto?.foto_grande || mascota.foto?.foto_thumb || ''"
        class="img-card pointer w-100 thumb-popup"
        [attr.data-full]="mascota.foto?.foto_grande || mascota.foto?.foto_thumb"
        [attr.data-titulo]="mascota.ma_nombre"
        [attr.data-texto1]="mascota.ma_tipo + ' ' + mascota.ma_raza + ' de ' + mascota.ma_edad"
        [attr.data-texto2]="(mascota.ma_sexo === 'Macho' ? '<i class=\'fa-solid fa-mars\'></i>' : mascota.ma_sexo === 'Hembra' ? '<i class=\'fa-solid fa-venus\'></i>' : '') + ' ' + mascota.ma_sexo"
      />
      <button type="button" *ngIf="fotosActivas().length > 1" class="pet-photo-arrow pet-photo-prev" (click)="moverFoto(-1)" aria-label="Foto anterior"><i class="fa-solid fa-chevron-left"></i></button>
      <button type="button" *ngIf="fotosActivas().length > 1" class="pet-photo-arrow pet-photo-next" (click)="moverFoto(1)" aria-label="Foto siguiente"><i class="fa-solid fa-chevron-right"></i></button>
      <div class="pet-thumbnails" cdkDropList cdkDropListOrientation="horizontal" [cdkDropListDisabled]="!mascota.edit" (cdkDropListDropped)="soltarMiniatura($event)">
        <!--FOTOS-->
        <div class="div-delete" *ngFor="let foto of (mascota.previewUrl || []); let i = index" cdkDrag [cdkDragDisabled]="!mascota.edit || foto.borrada">
          <!-- CDK muestra solo la fotografía al arrastrar; nunca clona los botones. -->
          <ng-template cdkDragPreview>
            <img [src]="foto.data || foto.url"
                 [alt]="'Foto de ' + (mascota.ma_nombre || 'mascota')"
                 style="display:block;width:68px;height:68px;object-fit:cover;border:2px solid #527B69;border-radius:12px;box-shadow:0 12px 24px rgba(22,51,38,.22);pointer-events:none;" />
          </ng-template>
          <button type="button" *ngIf="mascota.edit && !foto.borrada" class="pet-thumb-control pet-thumb-handle" cdkDragHandle title="Arrastrar para ordenar" aria-label="Arrastrar para ordenar foto"><i class="fa-solid fa-grip-vertical" aria-hidden="true"></i></button>
          <!-- Botón papelera flotante -->
          <button type="button" *ngIf="mascota.edit && !foto.borrada" class="pet-thumb-control pet-thumb-delete" (click)="$event.stopPropagation(); borrarFoto(i)" title="Eliminar foto" aria-label="Eliminar foto">
            <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
          </button>
          <button type="button" *ngIf="mascota.edit && foto.borrada" class="pet-thumb-control pet-thumb-recover" (click)="$event.stopPropagation(); borrarFoto(i)" title="Recuperar foto" aria-label="Recuperar foto">
            <i class="fa-solid fa-arrow-rotate-left" aria-hidden="true"></i>
          </button>
          <img [src]="foto.data || foto.url" class="pet-thumb" [attr.alt]="'Foto de '+(mascota.ma_nombre || 'mascota')" loading="lazy"
              [ngClass]="{'disabled-div': foto.borrada}"
              (click)="seleccionarFoto(foto)">
        </div>
        <div *ngIf="mascota.edit && numeroFotosActivas() < 6">
          <div class="add-photo-box d-flex justify-content-center align-items-center" (click)="onClickImagen()" title="Añadir foto">
            <i class="fa-regular fa-camera fs-3 text-secondary"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="pet-card-body">
      <div class="pet-title-row">
        <div class="pet-heading-main">
          <div class="pet-heading-line">
            <app-inline-edit class="pet-name" [modoEditar]="mascota.edit"
                [(ngModel)]="mascota.ma_nombre" inputClass="form-control fs-3">
              <h3>{{ mascota.ma_nombre || 'Nombre mascota' }}</h3>
            </app-inline-edit>
            <div class="pet-heading-actions" *ngIf="app.misdatos.ID == app.userid">
              <button type="button" class="pet-icon-button" (click)="editarMascota(mascota)"
                  [attr.aria-label]="mascota.edit ? 'Guardar mascota' : 'Editar mascota'"
                  [title]="mascota.edit ? 'Guardar' : 'Editar'"><i class="fa-solid" [ngClass]="mascota.edit ? 'fa-check' : 'fa-pen'"></i></button>
              <button type="button" class="pet-icon-button" *ngIf="mascota.edit" (click)="cancelarMascota(mascota)" title="Cancelar" aria-label="Cancelar"><i class="fa-solid fa-xmark"></i></button>
              <button type="button" class="pet-icon-button pet-icon-danger" *ngIf="!mascota.edit" (click)="app.borrarMascota(mascota)" title="Borrar" aria-label="Borrar"><i class="fa-regular fa-trash-can"></i></button>
            </div>
          </div>
          <div class="pet-subtitle">
            <app-inline-edit [modoEditar]="mascota.edit" class="mi-app-flex"
                [(ngModel)]="mascota.ma_raza" inputClass="form-control">
              <span title="Raza" [class.text-secondary]="!mascota.ma_raza">{{mascota.edit && mascota.ma_raza == '' ? 'Raza' : mascota.ma_raza}}</span>
            </app-inline-edit>
            <span class="pet-separator" *ngIf="mascota.ma_raza">·</span>
            <app-inline-edit [modoEditar]="mascota.edit" class="mi-app-flex"
                [(ngModel)]="mascota.ma_fecha_nac" [type]="'date'"
                inputClass="mi-app-flex form-control" (ngModelChange)="calcularEdad()">
              <span [class.text-secondary]="!mascota.ma_edad">{{mascota.ma_edad || 'Edad'}}</span>
            </app-inline-edit>
            <span class="pet-separator">·</span>
            <app-inline-edit [modoEditar]="mascota.edit" class="mi-app-flex"
                type="select" [options]="tipos_mascotas"
                [(ngModel)]="mascota.ma_tipo" inputClass="form-select">
              <span [class.text-secondary]="!mascota.ma_tipo">{{mascota.ma_tipo || 'Tipo'}}</span>
            </app-inline-edit>
          </div>
        </div>
        <div class="pet-visibility" *ngIf="app.misdatos.ID == app.userid">
          <button type="button" class="pet-visibility-badge"
              [class.is-hidden]="mascota.ma_novisible == 'X'"
              [class.is-editable]="mascota.edit"
              [disabled]="!mascota.edit"
              (click)="mascota.ma_novisible = (mascota.ma_novisible == 'X' ? '' : 'X')"
              [attr.aria-label]="(mascota.ma_novisible == 'X' ? 'No visible' : 'Visible') + (mascota.edit ? '. Cambiar visibilidad' : '')">
            <i class="fa-solid" [ngClass]="mascota.ma_novisible == 'X' ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
            <span>{{mascota.ma_novisible == 'X' ? 'No visible' : 'Visible'}}</span>
          </button>
        </div>
      </div>
      <div class="pet-note mt-3 mb-2">
        <app-inline-edit 
            [modoEditar]="mascota.edit"
            [(ngModel)]="mascota.ma_descripcion" 
            inputClass="form-control"
            type="textarea">
          <app-leer-mas 
            [class.text-secondary]="!mascota.ma_descripcion" 
            [texto]="mascota.ma_descripcion || 'Presenta a tu mascota, qué la hace especial... ¡y todas sus locuras!'" 
            [limite]="120" class="pointer"></app-leer-mas>
        </app-inline-edit>
      </div>
      <dl class="pet-details">
        <div class="pet-detail"><span class="pet-detail-icon"><i class="fa-solid fa-venus-mars"></i></span><span class="pet-detail-content"><dt>Sexo</dt><dd>
          <app-inline-edit 
              [modoEditar]="mascota.edit"
              type="select"
              [options]="['Macho', 'Hembra', 'Desconocido']"
              [(ngModel)]="mascota.ma_sexo" 
              inputClass="form-select">
            <span *ngIf="mascota.ma_sexo=='Macho'" title="Sexo"><i class="fa-solid fa-mars"></i></span>
            <span *ngIf="mascota.ma_sexo=='Hembra'" title="Sexo"><i class="fa-solid fa-venus"></i></span>
            <span title="Sexo">{{mascota.ma_sexo || '-'}}</span>
          </app-inline-edit>
        </dd></span></div>
        <div class="pet-detail"><span class="pet-detail-icon"><i class="fa-solid fa-paw"></i></span><span class="pet-detail-content"><dt>Tamaño</dt><dd>
          <app-inline-edit 
              [modoEditar]="mascota.edit"
              type="select"
              [options]="['Pequeño', 'Mediano', 'Grande']"
              [(ngModel)]="mascota.ma_tamano" 
              inputClass="form-select">
            <span title="Tamaño">{{mascota.ma_tamano || '-'}}</span>
          </app-inline-edit>
        </dd></span></div>
        <div class="pet-detail"><span class="pet-detail-icon"><i class="fa-solid fa-bolt"></i></span><span class="pet-detail-content"><dt>Energía</dt><dd>
          <app-inline-edit 
              [modoEditar]="mascota.edit"
              type="select"
              [options]="nivelesEnergia"
              [(ngModel)]="mascota.ma_energia" 
              inputClass="form-select"
              (ngModelChange)="queEnergia(mascota)">
            <span title="Nivel de energía">{{mascota.ma_energia_nombre || '-'}}</span>
          </app-inline-edit>
        </dd></span></div>
        <div class="pet-detail pet-detail-huellas">
          <span class="pet-detail-icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></span>
          <span class="pet-detail-content">
            <dt>Huellas</dt>
            <dd><button type="button" class="pet-paw-action"
                (click)="app.dejarHuella(mascota)"
                [attr.aria-label]="'Dejar huella. ' + (mascota.huellas || 0) + ' huellas'">
              <span>{{mascota.huellas || 0}} {{mascota.huellas == 1 ? 'huella' : 'huellas'}}</span>
              <i *ngIf="mascota.mihuella > 0" class="fa-solid fa-check pet-paw-done" aria-hidden="true"></i>
            </button></dd>
          </span>
        </div>
      </dl>
      <!--ATRIBUTOS-->
      <div class="trait-list mt-3" *ngIf="!mascota.edit">
        <span *ngFor="let atributo of mascota.atributos">
          {{atributo.at_atributo}}
        </span>
      </div>
      <div class="trait-list mt-3" *ngIf="mascota.edit">
        <span class="pointer" 
          *ngFor="let atributo of personalidades"
          [ngClass]="{'noselected': !personalidadesSeleccionadas.includes(atributo) }"
          (click)="onCheckChange(atributo)">
          {{atributo.va_nombre}}
        </span>
      </div>

      <div class="pet-favourite">
        <div class="pet-favourite-title"><i class="fa-solid fa-heart"></i> Lo que más me gusta de {{mascota.ma_nombre || 'mi mascota'}}</div>
        <textarea *ngIf="mascota.edit" class="form-control pet-favourite-editor" rows="3" maxlength="500" [(ngModel)]="mascota.ma_megusta" [ngModelOptions]="{standalone:true}" placeholder="¿Qué es lo que más te gusta de tu mascota?"></textarea>
        <small *ngIf="mascota.edit" class="pet-character-count">{{(mascota.ma_megusta || '').length}} / 500</small>
        <p *ngIf="!mascota.edit" class="pet-favourite-text">{{mascota.ma_megusta || 'Todavía no se ha añadido esta información.'}}</p>
      </div>
    </div>
    </div>
  </article>

<input
  type="file"
  multiple
  #fileInputFotosMascota
  accept="image/*"
  style="display: none"
  (change)="onFileSelected($event)"
/>
</div>